interface contactFormData {
    name: string;
    email: string;
    message: string;
}

export const sendContactFrom = async (data: contactFormData): Promise<void> => {
    try {
        const response = await fetch('https://api.eternity.ac/contact/meetmy-bot', {
            method: 'POST',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: data.name,
                email: data.email,
                message: data.message
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
    } catch (error) {
        throw new Error(`Failed to send email: ${(error as Error).message}`);
    }
};